import { gql } from '@apollo/client'

import type { BaseApplicantOverviewResponseModel } from '@/lib/apollo/model/applicant'
import type { PaginatedDataResponse } from '@/lib/apollo/model/pagination'
import type { Squad } from '@/utils/squad'

export type QueryVars = {
  customerId: string
  squad: Squad
  limit: number
  offset: number
}

export type ChasedApplicantResponse = Pick<
  BaseApplicantOverviewResponseModel,
  'id' | 'fullName'
>

export type Response = {
  getChasedApplicants: PaginatedDataResponse<ChasedApplicantResponse>
}

const query = gql`
  query ($customerId: String!, $squad: Squad!, $limit: Int!, $offset: Int!) {
    getChasedApplicants(
      customerId: $customerId
      squad: $squad
      limit: $limit
      offset: $offset
    ) {
      total
      offset
      results {
        id
        fullName
      }
    }
  }
`

export default query
